import styled from 'styled-components';
import { media, spacing } from '~/theme';

export const Spacer5 = styled.div`
    margin: ${spacing.spacing5};
`;

export const Spacer8 = styled.div`
    margin: ${spacing.spacing8};
`;

export const CostContainer = styled.div<{ $columns?: number }>`
    display: flex;
    flex-direction: column;
    gap: ${spacing.spacing4};
    width: 100%;

    @media ${media.small} {
        display: grid;
        grid-template-columns: repeat(${props => props.$columns ?? 3}, minmax(0, 1fr));
        column-gap: calc(${spacing.spacing9} + 6px);
        row-gap: ${spacing.spacing4};
    }
`;

export const DetailItem = styled.div`
    min-width: 190px;

    & p {
        margin: ${spacing.spacing0};
    }

    @media ${media.small} {
        min-width: 0;
    }
`;

export const CreditCardSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${spacing.spacing0};
    margin-top: ${spacing.spacing3};
    margin-bottom: ${spacing.spacing4};

    h6 {
        margin: ${spacing.spacing0};
        width: initial;
        white-space: nowrap;
    }

    @media ${media.small} {
        margin-bottom: ${spacing.spacing0};
    }
`;

export const CreditCardContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: ${spacing.spacing2};
    align-items: center;
    flex-wrap: nowrap;
    width: fit-content;
    max-width: 100%;

    p {
        margin: ${spacing.spacing0};
        white-space: nowrap;
    }

    @media ${media.small} {
        margin: ${spacing.spacing0} ${spacing.spacing0} ${spacing.spacing4} ${spacing.spacing0};
    }
`;

export const CostDeliveryContainer = styled.div`
    margin-top: ${spacing.spacing4};
    margin-bottom: ${spacing.spacing4};
`;

export const PayCardImageContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: ${spacing.spacing2};
    align-items: center;
    flex-wrap: nowrap;

    svg {
        flex-shrink: 0;
        display: block;
    }
`;
